import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "icon"]

  connect() {
    this.updateGreeting()
  }

  updateGreeting() {
    const hour = new Date().getHours()

    let greeting, iconClass

    if (hour >= 5 && hour < 12) {
      greeting = "Good morning"
      iconClass = "fa-mug-hot"
    } else if (hour >= 12 && hour < 17) {
      greeting = "Good afternoon"
      iconClass = "fa-sun"
    } else {
      greeting = "Good evening"
      iconClass = "fa-moon"
    }

    if (this.hasTextTarget) {
      this.textTarget.textContent = greeting
    }

    if (this.hasIconTarget) {
      // Remove existing icon classes and add the new one
      this.iconTarget.className = `fas ${iconClass} me-2`
    }
  }
}
